export const mapProductSliders = (products) => {
  const sliders = products.map(({ title, brands: productBrands }) => {
    const filteredProductBrands = productBrands.filter(
      ({ available }) => available
    );
    const brands = filteredProductBrands.map(
      ({ circle_icon_url, brand_name, savings, cash_back, slug }) => {
        const hasSavings = savings !== 0;
        const hasCashBack = cash_back !== 0;

        const discount = Math.ceil(savings * 10) / 10;
        const cashBack = Math.ceil(cash_back * 10) / 10;
        const discountText = `Up to ${discount}% off${
          hasCashBack ? " | " : ""
        }`;
        const cashBackText = `${cashBack}% GCX Cash`;

        const subtext = `${hasSavings || !hasCashBack ? discountText : ""}${
          hasCashBack ? cashBackText : ""
        }`;

        return {
          image: circle_icon_url,
          brandName: brand_name,
          info: subtext,
          linkTo: `/buy-${slug}-gift-cards`
        };
      }
    );

    return {
      title,
      brands
    };
  });

  return sliders;
};
